import React from "react";
import { useMemo, useState } from "react";
import _ from "lodash";

export default function SearchBar({ setSearch, onSearch, debounce }) {

  const onSearchChange = (evt) => {
    let query = evt.target.value.trim();
    setSearch(evt.target.value);
  }

  // debounce setting the actual thingy
  const debouncedChange = useMemo(
    () => _.debounce(onSearchChange, 500),
    [onSearchChange]
  );

  return (
    <div className="search-order-row">
      <input type="text" className="search-bar"
        placeholder="Type here..."
        // value={search}
        onChange={debounce ? debouncedChange : onSearchChange}
        // quick inline function to search if the key pressed was enter, yes i know it's a one-liner
        onKeyDown={evt => { if (evt.key === "Enter") { evt.preventDefault(); onSearch() } }}
      />
      <button onClick={onSearch}> Search </button>
    </div>
  );
}